import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Receipt, ArrowRight } from "lucide-react";
import api, { GHS } from "@/lib/api";
import { StatusBadge } from "@/components/StatusBadge";

export default function PaymentHistory() {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);

  useEffect(() => { api.get("/payments/history").then(({ data }) => setItems(data)); }, []);

  return (
    <div data-testid="payment-history-page">
      <p className="vw-label">Payments</p>
      <h1 className="font-display text-2xl sm:text-3xl font-bold text-white mt-1 mb-6">Payment History</h1>

      {items === null ? (
        <div className="h-32 rounded-2xl bg-slate-800/50 animate-pulse" />
      ) : items.length === 0 ? (
        <div className="vw-card p-10 text-center">
          <Receipt className="mx-auto text-slate-600 mb-3" size={32} />
          <p className="text-slate-400">No payments yet.</p>
          <button onClick={() => navigate("/plans")} className="vw-btn-primary mt-5 inline-flex items-center gap-2" data-testid="ph-view-plans">VIEW PLANS <ArrowRight size={16} /></button>
        </div>
      ) : (
        <div className="space-y-3">
          {items.map((p) => (
            <div key={p.id} className="vw-card p-5 flex flex-wrap items-center justify-between gap-4" data-testid={`payment-row-${p.id}`}>
              <div>
                <div className="font-display font-bold text-white">{p.plan_name}</div>
                <div className="text-xs text-slate-500 font-mono mt-0.5">{new Date(p.submitted_at).toLocaleString()}</div>
                {p.reference ? <div className="text-xs text-slate-500 mt-0.5">Ref: {p.reference}</div> : null}
              </div>
              <div className="text-right">
                <div className="font-display font-bold text-white">{GHS(p.amount)}</div>
              </div>
              <StatusBadge status={p.status} testid={`payment-status-${p.id}`} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
